import {
  Box,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { BoardID } from 'BoardID';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { getCtor } from 'boardClasses/BoardFactory';
import {
  selectBoardName,
  selectBoardType,
  selectedBoardIDAtom,
} from 'state/recoilState';
import { isDev } from 'utils/utils';

function BoardListItem(props: { boardID: BoardID }) {
  const { boardID } = props;

  const boardName = useRecoilValue(selectBoardName(boardID));
  const boardType = useRecoilValue(selectBoardType(boardID));
  const boardCtor = boardType && getCtor(boardType);
  const selectedBoardID = useRecoilValue(selectedBoardIDAtom);
  const isSelected = boardID === selectedBoardID;

  const theme = useTheme();

  if (!isDev() && boardCtor?.isDevOnly) {
    return null;
  }

  return (
    <Link
      key={boardID}
      to={`/designer/id/${boardID}${window.location.search}`}
      style={{
        color: 'inherit',
        textDecoration: 'none',
      }}
    >
      <ListItemButton selected={isSelected}>
        <ListItemText
          primary={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography
                variant="body2"
                style={{
                  overflow: 'hidden',
                  paddingRight: theme.spacing(1),
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {boardName}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {boardType}
              </Typography>
            </Box>
          }
        ></ListItemText>
      </ListItemButton>
    </Link>
  );
}

export default BoardListItem;
